<p>
  Filter:
  <input type="checkbox" [(ngModel)]="filtered">
  <span class="spacer"></span>
  First:
  <input type="checkbox" [ngModel]="firstLast == 'first'" (ngModelChange)="firstLast = $event ? 'first' : 'last'">
  <span class="spacer"></span>
  Number:
  <input type="number" [(ngModel)]="nr">
  <span class="spacer"></span>
  UnreadOnly:
  <input type="checkbox" [(ngModel)]="unreadOnly">
  <span class="spacer"></span>
  <button type="button" class="btn btn-primary" (click)="filter()">Filter</button>
</p>

<table class="table table-hover">
  <thead>
    <tr>
      <th>id</th>
      <th>filename</th>
      <th>time</th>
      <th>playedAt</th>
      <th>actions</th>
    </tr>
  </thead>
  <tbody>
    @for (recording of recordings; track recording.id; let i = $index) {
      <tr>
        <td>{{recording.id}}</td>
        <td>{{recording.filename}}</td>
        <td>{{recording.time | date:'yyyy-MM-dd HH:mm:ss' : 'Europe/Vienna' : 'en-DK'}}</td>
        <td>{{recording.playedAt | date:'yyyy-MM-dd HH:mm:ss' : 'Europe/Vienna' : 'en-DK'}}</td>
        <td class="lk-container">
          <a (click)="play(i, false)" class="link">play</a>
          <a (click)="play(i, true)" class="link">play from here</a>
          <a (click)="stopped = true" class="link">stop</a>
          @if (recording.playing) {
            <span>…</span>
          }
        </td>
      </tr>
    }
  </tbody>
</table>
